module.exports = __webpack_public_path__ + "img/ldh_tzcp.56b75be2.png";